//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'childHealth',
  data () {
    return {
      deviceData: '',
      bloodOxygen: null,
      heartRate: null,
      bodyTemperature: null
    }
  },
  created () {
    this.deviceData = this.$store.getters.get_child_obj
    this.bloodOxygen = this.deviceData.mainConfig.bloodOxygen ? this.deviceData.mainConfig.bloodOxygen : null
    this.heartRate = this.deviceData.mainConfig.heartRate ? this.deviceData.mainConfig.heartRate : null
    this.bodyTemperature = this.deviceData.mainConfig.bodyTemperature ? this.deviceData.mainConfig.bodyTemperature : null
  },
  methods: {
    getShow (val, type) {
      let result = ''
      if (val) {
        if (type === 'bloodOxygen') {
          result = parseFloat(val.value) < 95 || parseFloat(val) > 98
        } else if (type === 'heartRate') {
          result = parseFloat(val.value) < 60 || parseFloat(val) > 100
        } else if (type === 'bodyTemperature') {
          result = parseFloat(val.value) < 36 || parseFloat(val) > 37.5
        }
      }
      return result
    },
    getTime (val) {
      let result = ''
      if (val) {
        let date = new Date(val.time)
        result = date.format('yyyy-MM-dd hh:mm:ss')
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/childHealth.vue